import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, BookOpen } from 'lucide-react';

export default function ArtikelRamadanFuerAnfaenger() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Ramadan für Anfänger: Alles was du wissen musst</h1>
          <p className="text-lg text-white/80 leading-relaxed">Der ultimative Guide für alle, die zum ersten Mal Ramadan erleben – ob als Muslim oder als interessierter Nachbar.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Ramadan ist der heiligste Monat im Islam – ein Monat des Fastens, der Besinnung und der Gemeinschaft. Ob du als Muslim zum ersten Mal bewusst fastest, neu konvertiert bist oder einfach mehr über den Ramadan deiner Nachbarn, Kollegen oder Freunde erfahren möchtest: Dieser Guide erklärt dir alles Wichtige.</p>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 md:p-8 mb-12">
            <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">Inhaltsverzeichnis</h2>
            <ul className="space-y-2 text-[#4A5D4F]">
              <li><a href="#was-ist-ramadan" className="hover:underline">1. Was ist Ramadan?</a></li>
              <li><a href="#fasten" className="hover:underline">2. Wie funktioniert das Fasten?</a></li>
              <li><a href="#tagesablauf" className="hover:underline">3. Der typische Ramadan-Tagesablauf</a></li>
              <li><a href="#tipps" className="hover:underline">4. Praktische Tipps für Anfänger</a></li>
              <li><a href="#nicht-muslime" className="hover:underline">5. Als Nicht-Muslim: Wie du unterstützen kannst</a></li>
            </ul>
          </div>

          <section id="was-ist-ramadan" className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><BookOpen className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">1. Was ist Ramadan?</h2>
            </div>
            <div className="space-y-4">
              <p className="text-[#4B5563]">Ramadan ist der neunte Monat des islamischen Mondkalenders. Während dieses Monats fasten Muslime weltweit von der Morgendämmerung bis zum Sonnenuntergang – kein Essen, kein Trinken.</p>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Die fünf Säulen des Islam</h4>
                <p className="text-sm text-[#4B5563]">Das Fasten im Ramadan (Sawm) ist eine der fünf Säulen des Islam – neben dem Glaubensbekenntnis (Shahada), dem Gebet (Salat), der Almosengabe (Zakat) und der Pilgerfahrt nach Mekka (Hajj).</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Wann ist Ramadan 2026?</h4>
                <p className="text-sm text-[#4B5563]">Ramadan 2026 beginnt voraussichtlich am 18. Februar und endet am 19. März. Das genaue Datum hängt von der Mondsichtung ab. Danach wird Eid ul Fitr gefeiert.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Warum wird gefastet?</h4>
                <p className="text-sm text-[#4B5563]">Das Fasten fördert Disziplin, Empathie für Bedürftige, Dankbarkeit und spirituelle Reinigung. Es ist auch eine Zeit der verstärkten Quran-Lesung und des Gebets.</p>
              </div>
            </div>
          </section>

          <section id="fasten" className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">2. Wie funktioniert das Fasten?</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Suhoor (Morgenmahl)</h4>
                <p className="text-sm text-[#4B5563]">Vor der Morgendämmerung (Fajr) wird eine letzte Mahlzeit eingenommen. Empfohlen: Komplexe Kohlenhydrate, Proteine und viel Wasser.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Fastenzeit</h4>
                <p className="text-sm text-[#4B5563]">Von der Morgendämmerung bis zum Sonnenuntergang: Kein Essen, Trinken oder Rauchen. In Deutschland je nach Jahreszeit zwischen 12 und 18 Stunden.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Iftar (Fastenbrechen)</h4>
                <p className="text-sm text-[#4B5563]">Bei Sonnenuntergang wird das Fasten traditionell mit Datteln und Wasser gebrochen, gefolgt von einer Mahlzeit. Oft wird gemeinsam in der Moschee oder mit der Familie gegessen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Wer ist befreit?</h4>
                <p className="text-sm text-[#4B5563]">Kinder vor der Pubertät, Schwangere, Stillende, Reisende, Kranke und ältere Menschen sind vom Fasten befreit. Stattdessen kann Fidya (Speisung eines Bedürftigen) gegeben werden.</p>
              </div>
            </div>
          </section>

          <section id="tagesablauf" className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">3. Der typische Ramadan-Tagesablauf</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">ca. 4:30 – Suhoor</h4>
                <p className="text-sm text-[#4B5563]">Aufstehen, essen, Wasser trinken, Fajr-Gebet verrichten.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Tagsüber – Arbeit & Alltag</h4>
                <p className="text-sm text-[#4B5563]">Normaler Tagesablauf. Viele Muslime lesen zusätzlich Quran, machen Dhikr (Gedenken Allahs) und versuchen, besonders geduldig und freundlich zu sein.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">ca. 17:30 – Iftar</h4>
                <p className="text-sm text-[#4B5563]">Fastenbrechen mit Datteln und Wasser. Maghrib-Gebet, dann gemeinsames Essen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">ca. 20:00 – Tarawih-Gebet</h4>
                <p className="text-sm text-[#4B5563]">Freiwilliges Nachtgebet in der Moschee. Viele Muslime nehmen jede Nacht daran teil. Es wird der gesamte Quran im Laufe des Monats rezitiert.</p>
              </div>
            </div>
          </section>

          <section id="tipps" className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">4. Praktische Tipps für Anfänger</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-3">
                <li><strong>Suhoor nie auslassen:</strong> Auch wenn du müde bist – ohne Suhoor wird der Tag sehr lang</li>
                <li><strong>Langsam anfangen:</strong> Wenn du noch nie gefastet hast, beginne mit kürzeren Fastenzeiten</li>
                <li><strong>Viel Wasser trinken:</strong> Zwischen Iftar und Suhoor mindestens 2-3 Liter</li>
                <li><strong>Ausgewogen essen:</strong> Vermeide zu viel Zucker und Fett – dein Körper braucht Nährstoffe</li>
                <li><strong>Schlafrhythmus anpassen:</strong> Früher ins Bett gehen, um für Suhoor ausgeruht zu sein</li>
                <li><strong>Gemeinschaft suchen:</strong> In der Moschee Iftar essen oder Freunde einladen</li>
                <li><strong>Nicht überessen:</strong> Nach einem Tag Fasten ist die Versuchung groß, aber der Magen braucht Zeit</li>
                <li><strong>Geduldig sein:</strong> Die ersten Tage sind die schwersten – es wird besser!</li>
              </ul>
            </div>
          </section>

          <section id="nicht-muslime" className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">5. Als Nicht-Muslim: Wie du unterstützen kannst</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Verständnis zeigen</h4>
                <p className="text-sm text-[#4B5563]">Dein Kollege ist vielleicht müder als sonst oder lehnt das Mittagessen ab. Das ist normal – ein "Ich verstehe" reicht völlig.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"Ramadan Mubarak" sagen</h4>
                <p className="text-sm text-[#4B5563]">Ein herzliches "Ramadan Mubarak" (Gesegneter Ramadan) wird immer mit Freude aufgenommen. Es zeigt Respekt und Interesse.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Zum Iftar einladen lassen</h4>
                <p className="text-sm text-[#4B5563]">Frag doch mal, ob du bei einem Iftar dabei sein darfst! Die meisten Muslime freuen sich sehr über interessierte Gäste.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Kleine Geschenke machen</h4>
                <p className="text-sm text-[#4B5563]">Datteln, Süßigkeiten oder eine "Eid Mubarak"-Karte zum Fest – eine kleine Geste mit großer Wirkung.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Ramadan ist viel mehr als Hungern – es ist eine Zeit der inneren Einkehr, der Gemeinschaft und der Freude. Ob du zum ersten Mal fastest oder einfach mehr verstehen möchtest: Die Offenheit und das Interesse sind schon ein wunderbarer erster Schritt.</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Ramadan Kareem!</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/was-ist-eid" className="text-[#4A5D4F] hover:underline">→ Was ist Eid? Ein Leitfaden</Link></li>
              <li><Link to="/ratgeber/ramadan-geschenke" className="text-[#4A5D4F] hover:underline">→ Ramadan Geschenke Guide</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
